import moment from 'moment'
import _get from 'lodash/get'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  formComplete: false,
  formData: {},
  loading: true,
  isDebug: true,
  isReadOnly: false,

  showPreview: true,
  showAttachments: true,
  communicationID: 0,
  composedText: '',
  composedSubject: '',
  files: [],
  image: null,
  doc: null,
  previews: [],
  lGet: _get,
  activeTab: 0,
  documents: [],
  communicationAttachments: [],
  communicationAttachmentFile: null,

  formatDateFn: function(value) {
    return value && value != undefined
      ? moment(value.toString(), 'YYYY/MM/DD HH:mm:ss')
          .format('MM-DD-YYYY')
          .toString()
      : ''
  },
  styles: {
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
